import type { Translations } from "./en";

export const es: Translations = {
  common: {
    back: "← Atrás",
    next: "Siguiente →",
    save: "Guardar",
    saving: "Guardando…",
    cancel: "Cancelar",
    creating: "Creando…",
    loading: "Cargando…",
    error: "Error",
    optional: "(opcional)",
    skip: "Omitir",
    open: "Abrir →",
    signOut: "Cerrar sesión",
    signingOut: "Cerrando sesión…",
    approve: "Aprobar",
    reject: "Rechazar",
    add: "Agregar",
    edit: "Editar",
    delete: "Eliminar",
    name: "Nombre",
    description: "Descripción",
    amount: "Monto",
    date: "Fecha",
    title: "Título",
    status: "Estado",
    location: "Ubicación",
    notes: "Notas",
    yes: "Sí",
    no: "No",
    project: "Proyecto",
  },

  nav: {
    menu: "Menú",
    pages: "Páginas",
    dashboard: "Panel",
    projects: "Proyectos",
    estimates: "Estimaciones",
    estimator: "Estimador",
    expenses: "Gastos",
    categories: "Categorías",
    pricing: "Hoja de precios",
    account: "Cuenta",
    signOut: "Cerrar sesión",
    signingOut: "Cerrando sesión…",
    homeAria: "Inicio de ScapeQuote",
    toggleMenu: "Abrir o cerrar el menú",
  },

  footer: {
    rights: "© {{year}} · Todos los derechos reservados",
  },

  login: {
    forgotPassword: "¿Olvidó su contraseña?",
    welcomeBack: "Bienvenido de nuevo",
    signIn: "Iniciar sesión",
    email: "Correo electrónico",
    password: "Contraseña",
    show: "Mostrar",
    hide: "Ocultar",
    pleaseWait: "Por favor espera…",
    pleaseEnter: "Por favor ingrese su correo y contraseña.",
    noAccount: "¿No tiene cuenta?",
    signUpLink: "Regístrate",
    authFailed: "Error de autenticación.",
    showPasswordAria: "Mostrar contraseña",
    hidePasswordAria: "Ocultar contraseña",
  },

  signup: {
    getStarted: "Comenzar",
    createAccount: "Crear cuenta",
    name: "Nombre",
    yourFullName: "Su nombre completo",
    email: "Correo electrónico",
    password: "Contraseña",
    minChars: "Mín. 8 caracteres",
    busy: "Creando…",
    alreadyAccount: "¿Ya tiene cuenta?",
    signInLink: "Inicia sesión",
    enterName: "Por favor ingrese su nombre.",
    validEmail: "Por favor ingrese un correo electrónico válido.",
    passwordLength: "La contraseña debe tener al menos 8 caracteres.",
    enterEmail: "Por favor ingrese un correo electrónico válido.",
    enterPassword: "La contraseña debe tener al menos 8 caracteres.",
    failed: "No se pudo crear la cuenta.",
    confirmPassword: "Confirme la contraseña",
    confirmPasswordPh: "Escríbala otra vez",
    passwordsNoMatch: "Las contraseñas no coinciden.",
  },

  dashboard: {
    eyebrow: "Panel",
    welcome: "Bienvenido, {{name}}",
    subtitle: "Su resumen de proyectos y presupuestos.",
    newProject: "+ Nuevo proyecto",
    quickActions: "Acciones rápidas",
    createProject: "Crear proyecto",
    viewAllProjects: "Ver todos los proyectos",
    newEstimate: "Nueva estimación",
    allEstimates: "Todas las estimaciones",
    expenseTracker: "Control de gastos",
    recentProjects: "Proyectos recientes",
    viewAll: "Ver todos →",
    noProjects: "Aún no hay proyectos — cree el primero.",
    budgetSnapshot: "Resumen de presupuesto",
    contract: "Contrato (aprobado)",
    pipeline: "Cotizaciones abiertas",
    expenses: "Gastos",
    remaining: "Restante",
    grossProfit: "Ganancia bruta",
    margin: "Margen",
    noFinancialData: "Sin datos financieros aún.",
    loading: "Cargando proyectos…",
    loadingBudget: "Cargando…",
    projectProfitTracker: "Seguimiento de ganancias por proyecto",
    projectName: "Proyecto",
    fallbackName: "amigo",
    loadFailed: "No se pudieron cargar los datos del panel",
    noLocation: "Sin ubicación",
  },

  projects: {
    eyebrow: "Su trabajo",
    title: "Proyectos",
    newProject: "+ Nuevo proyecto",
    noProjectsYet: "Aún no hay proyectos",
    createFirst: "Cree su primer proyecto para comenzar.",
    openProject: "Abrir →",
    loadFailed: "No se pudieron cargar los proyectos",
    confirmDelete: "¿Eliminar \"{{name}}\"?\n\nSe borrarán para siempre el proyecto y todas sus estimaciones, gastos y órdenes de cambio.",
    deleteFailed: "No se pudo eliminar el proyecto",
    deleteProject: "Eliminar proyecto",
    deleting: "Eliminando…",
  },

  projectWizard: {
    eyebrow: "Nuevo trabajo",
    title: "Crear proyecto",
    step_basics: "Básico",
    step_scope: "Alcance",
    step_location: "Ubicación",
    projectName: "Nombre del proyecto",
    notesOptional: "Notas (opcional)",
    notesPlaceholder: "Cualquier detalle sobre el proyecto…",
    next: "Siguiente →",
    back: "← Atrás",
    selectScope: "Seleccionar elementos del alcance",
    itemsSelected_one: "{{count}} elemento seleccionado: {{items}}",
    itemsSelected_other: "{{count}} elementos seleccionados: {{items}}",
    projectLocation: "Dirección de la obra",
    locationNote: "La dirección de la obra. Se imprime en sus propuestas.",
    createProject: "Crear proyecto",
    creating: "Creando…",
    mustBeLoggedIn: "Debes iniciar sesión antes de crear un proyecto.",
  },

  projectDetail: {
    eyebrow: "Proyecto",
    backToProjects: "← Proyectos",
    newEstimate: "+ Nueva estimación",
    estimatesSection: "Estimaciones",
    noEstimates: "Aún no hay estimaciones. Cree una para comenzar.",
    changeOrdersSection: "Órdenes de cambio",
    noChangeOrders: "Sin órdenes de cambio aún.",
    addChangeOrder: "+ Agregar orden de cambio",
    cancelAdd: "Cancelar",
    newChangeOrderLabel: "Nueva orden de cambio",
    titlePlaceholder: "ej. Agregar muro de contención",
    amountLabel: "Monto ($)",
    amountPlaceholder: "ej. 2400.00",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "Alcance del trabajo para este cambio",
    createChangeOrder: "Crear orden de cambio",
    saving: "Guardando…",
    estimatesTotal: "Total de estimaciones",
    approvedCOs: "OC aprobadas",
    contractValue: "Valor del contrato",
    expenses: "Gastos",
    grossProfit: "Ganancia bruta",
    profitMargin: "Margen de ganancia",
    trackExpenses: "Registrar gastos →",
    created: "Creado {{date}}",
    notFound: "Proyecto no encontrado.",
    loadFailed: "Error al cargar el proyecto",
    confirmDelete: "¿Eliminar \"{{name}}\"?\n\nSe borrarán para siempre el proyecto y todas sus estimaciones, gastos y órdenes de cambio.",
    deleteProject: "Eliminar proyecto",
    deleteFailed: "No se pudo eliminar el proyecto",
    statusUpdateFailed: "No se pudo actualizar el estado",
    actionFailed: "No se pudo completar la acción",
    createCoFailed: "No se pudo crear la orden de cambio",
    coStatusPending: "Pendiente",
    coStatusApproved: "Aprobada",
    coStatusRejected: "Rechazada",
  },

  estimateWizard: {
    eyebrow: "Cree su",
    title: "Estimación",
    quickMode: "Modo rápido",
    guidedMode: "Guiado (8 fases)",
    noProjects: "Sin proyectos",
    noProjectsNote: "Aún no hay proyectos —",
    createOneFirst: "crea uno primero",
    estimateTitleLabel: "Título de la estimación",
    optional: "(opcional)",
    titlePlaceholder: "ej. Fase 1 – Patio trasero",
    category: "Categoría",
    noCategories: "No se encontraron categorías",
    noCategoriesNote: "Ejecuta el SQL de configuración en Supabase para habilitarlas.",
    area: "Área (pies²)",
    areaPlaceholder: "ej. 300",
    state: "Estado",
    statePlaceholder: "ej. CA",
    zip: "Código postal",
    zipPlaceholder: "ej. 94103",
    createEstimate: "Crear estimación",
    creating: "Creando…",
    guidedTitlePlaceholder: "ej. Renovación completa del jardín",
    phase: "Fase {{num}} de {{total}}",
    skip: "Omitir",
    nextPhase: "Siguiente fase →",
    createFullEstimate: "Crear estimación completa",
    phasesConfigured: "Fases configuradas",
    resultEyebrow: "Resultado",
    subtotal: "Subtotal",
    tax: "Impuesto",
    total: "Total",
    lineItems: "Partidas",
    openPdf: "Abrir PDF ↗",
    viewProposal: "Ver propuesta",
    items: "{{count}} elementos",
    waste: "{{pct}}% desperdicio",
    phases: {
      demo:       "Demolición / Prep. del sitio",
      demoHint:   "Demolición, remoción de escombros, nivelación",
      soil:       "Preparación del suelo",
      soilHint:   "Enmienda del suelo, labranza, tierra vegetal",
      irrigation: "Irrigación",
      irrigationHint: "Líneas de goteo, sistemas de aspersores",
      hardscape:  "Paisaje duro",
      hardscapeHint: "Patios, senderos, muros de contención",
      planting:   "Siembra / Césped",
      plantingHint: "Plantas, árboles, césped, cobertura del suelo",
      mulch:      "Mantillo",
      mulchHint:  "Corteza, piedra, mantillo decorativo",
      lighting:   "Iluminación",
      lightingHint: "Iluminación de paisaje y caminos",
      cleanup:    "Limpieza final",
      cleanupHint: "Limpieza final, remoción, lista de pendientes",
    },
    review: "Revisar",
    stepOf: "Paso {{step}} de {{total}}",
    leaveBlankNote: "Deje en blanco lo que no use.",
    estimateCreated: "Estimación creada",
    newEstimate: "Nueva estimación",
    contractType: "Tipo de contrato",
    contractLumpSum: "Precio global",
    contractTimeAndMaterials: "Tiempo y materiales",
    lumpSumNote: "Un precio total. Sin línea de impuesto: el impuesto de materiales ya está en su costo.",
    timeAndMaterialsNote: "Se factura el tiempo y material reales. Impuesto solo sobre materiales; la mano de obra no paga impuesto.",
    taxOnMaterialsPct: "Impuesto materiales ({{pct}}%)",
    salesTaxOnMaterialsPct: "Impuesto sobre materiales ({{pct}}%)",
    materialsCostNote: "Solo para usted: costo de materiales {{cost}} · margen {{markup}}",
    setTaxRateBefore: "Configure su tasa de impuesto local en",
    priceSheetLink: "la hoja de precios",
    setTaxRateAfter: "antes de cotizar tiempo y materiales.",
    nothingEntered: "Aún no hay artículos. Elija una sección arriba e ingrese cantidades.",
    thisSection: "Esta sección",
    previewNote: "Vista previa. El total final lo calcula el servidor con su hoja de precios.",
    fixQuantities: "Corrija las cantidades marcadas en naranja.",
    quantityAria: "Cantidad de {{item}}",
    calcFromArea: "Calcular por área",
    calcArea: "Área (pie²)",
    calcDepth: "Espesor (pulg)",
    calcDensity: "Ton / yd³",
    calcEnterArea: "Ingrese el área.",
    calcUse: "Usar",
    suggestHours: "Sugerir horas según las plantas",
    kindMaterial: "Material",
    kindEquipment: "Equipo",
    kindLabor: "Mano de obra",
    priceMaterial: "Usted paga",
    priceEquipment: "Costo renta",
    priceLabor: "Usted cobra",
  },

  estimatesList: {
    eyebrow: "Todas las estimaciones",
    title: "Estimaciones",
    loading: "Cargando…",
    noEstimates: "Aún no hay estimaciones.",
    filterAll: "Todas",
    filterDraft: "Borrador",
    filterSent: "Enviada",
    filterApproved: "Aprobada",
    filterRejected: "Rechazada",
    statusDraft: "Borrador",
    statusSent: "Enviada",
    statusApproved: "Aprobada",
    statusRejected: "Rechazada",
    totalEstimates: "Total de estimaciones",
    totalValue: "Valor total",
    approvedValue: "Valor aprobado",
    pending: "Pendientes",
    project: "Proyecto",
    date: "Fecha",
    pdfLink: "PDF ↗",
    proposalLink: "Propuesta",
    loadFailed: "No se pudieron cargar las estimaciones",
    statusUpdateFailed: "No se pudo actualizar el estado",
    deleteFailed: "No se pudo eliminar la estimación",
    renameFailed: "No se pudo cambiar el nombre de la estimación",
    confirmDelete: "¿Eliminar \"{{label}}\"? Esta acción no se puede deshacer.",
    estimateNumber: "Estimación #{{num}}",
    noneForFilter: "No hay estimaciones en estado {{status}}.",
    createFirst: "Cree su primera estimación para comenzar.",
    titlePlaceholder: "Título de la estimación…",
    rename: "Cambiar nombre",
    inclTax: "incl. {{amount}} de impuesto",
    approvedLocked: "Las estimaciones aprobadas quedan bloqueadas — use una orden de cambio",
    viewProject: "Ver proyecto",
    deleteEstimate: "Eliminar estimación",
    deleting: "Eliminando…",
  },


  expenses: {
    eyebrow: "Control de gastos",
    title: "Gastos",
    project: "Proyecto",
    noProjects: "Sin proyectos",
    export: "Exportar",
    expensesCsv: "Gastos CSV",
    budgetCsv: "Presupuesto CSV",
    budgetSnapshot: "Resumen del presupuesto",
    noProjectSelected: "Ningún proyecto seleccionado",
    createProjectFirst: "Aún no hay proyectos. Cree uno para registrar gastos.",
    createProjectFirstReceipts: "Cree un proyecto para subir recibos y registrar gastos.",
    baseline: "Presupuesto",
    actual: "Gastado",
    remaining: "Restante",
    byCategory: "Por categoría",
    cat: {
      MATERIAL: "Materiales",
      LABOR: "Mano de obra",
      EQUIPMENT: "Equipo",
      SUBCONTRACTOR: "Subcontratista",
      OTHER: "Otro",
    },
    left: "Quedan {{amount}}",
    noBaseline: "Aún no hay presupuesto. Apruebe una estimación para crearlo.",
    logExpense: "Registrar gasto",
    category: "Categoría",
    vendor: "Proveedor",
    vendorPh: "p. ej. Home Depot",
    amount: "Monto ($)",
    date: "Fecha",
    description: "Descripción (opcional)",
    descriptionPh: "Descripción breve",
    addExpense: "+ Agregar gasto",
    countExpenses: "{{count}} gastos",
    none: "Aún no hay gastos registrados.",
    loading: "Cargando…",
    categorize: "Categorizar",
    edit: "Editar",
    delete: "Eliminar gasto",
    cancel: "Cancelar",
    saving: "Guardando…",
    saveChanges: "Guardar cambios",
    saveFailed: "No se pudo guardar el gasto.",
    deleteFailed: "No se pudo eliminar el gasto.",
    confirmDelete: "¿Eliminar \"{{label}}\"? Esta acción no se puede deshacer.",
  },

  receipt: {
    title: "Subir recibo",
    preparing: "Preparando la subida…",
    uploading: "Subiendo…",
    reading: "Leyendo el recibo y creando el gasto…",
    processing: "Trabajando…",
    upload: "Subir y crear gasto",
    noProject: "Elija un proyecto antes de subir un recibo.",
    signFailed: "No se pudo iniciar la subida. Intente de nuevo.",
    doneWithAmount: "Recibo guardado. Se creó un gasto por {{amount}}.",
    doneNeedsDetails: "Recibo guardado y adjuntado. Agregue el proveedor y el monto para completar el gasto.",
  },

  demo: {
    banner: "Estás explorando la demostración de ScapeQuote — datos de ejemplo, compartidos, que se reinician cada hora.",
    leave: "Salir de la demostración",
  },

  forgot: {
    eyebrow: "Contraseña",
    title: "Recupérala",
    intro: "Escribe el correo con el que inicias sesión. Te enviaremos un enlace para elegir una nueva contraseña.",
    send: "Enviar enlace",
    sending: "Enviando…",
    sent: "Si ese correo tiene una cuenta, el enlace va en camino.",
    sentHint: "Vence en una hora. Revise su carpeta de spam si no llega en unos minutos.",
    backToSignIn: "Volver a iniciar sesión",
    failed: "No se pudo enviar el enlace. Inténtalo de nuevo.",
  },

  reset: {
    eyebrow: "Contraseña",
    title: "Nueva contraseña",
    newPassword: "Nueva contraseña",
    confirm: "Confirmar nueva contraseña",
    save: "Guardar contraseña",
    saving: "Guardando…",
    done: "Contraseña cambiada. Te llevamos a iniciar sesión…",
    noToken: "Esta página necesita el enlace de su correo.",
    requestNew: "Envíame un enlace nuevo",
    tooShort: "La contraseña debe tener al menos 8 caracteres.",
    noMatch: "Las dos contraseñas no coinciden.",
    failed: "No se pudo cambiar la contraseña. Pida un enlace nuevo.",
  },

  proposalSettings: {
    section: "Empresa y propuestas",
    hint: "Se imprime en el encabezado de cada propuesta que envíes.",
    companyName: "Nombre de la empresa",
    companyNamePh: "p. ej. Greenline Landscaping",
    license: "N.º de licencia de contratista",
    licensePh: "p. ej. 1098765",
    licenseHint: "California exige su número de licencia CSLB en ofertas y contratos.",
    email: "Correo de la empresa",
    emailPh: "p. ej. cotizaciones@tuempresa.com",
    emailHint: "Se muestra en las propuestas. Déjalo en blanco para usar el correo con el que inicias sesión.",
    phone: "Teléfono de la empresa",
    address: "Dirección de la empresa",
    addressPh: "Calle, ciudad, estado, código postal",
    validDays: "Validez de las propuestas (días)",
    terms: "Sus condiciones (opcional)",
    termsPh: "p. ej. 50% de anticipo al firmar; el resto al terminar.",
    termsHint: "Se imprime en Condiciones en cada propuesta.",
    save: "Guardar datos de la empresa",
    saved: "Guardado. Las nuevas propuestas usarán estos datos.",
    validDaysRange: "Ingrese un número de días entre 1 y 365.",
  },

  client: {
    saveFailed: "No se pudo guardar",
    section: "Cliente",
    name: "Nombre del cliente",
    namePh: "p. ej. María García",
    phone: "Teléfono del cliente",
    email: "Correo del cliente",
    none: "Aún no hay datos del cliente — se imprimen en la propuesta en Preparado para.",
    edit: "Editar",
    add: "Agregar datos del cliente",
    save: "Guardar",
    cancel: "Cancelar",
    optional: "Cliente (opcional)",
    optionalHint: "Se imprime en la propuesta. Puedes agregarlo o cambiarlo después en la página del proyecto.",
  },

  proposalWarnings: {
    noLicense: "No ha configurado su número de licencia de contratista, así que no se imprimirá en esta propuesta.",
    noCompany: "No ha configurado el nombre de su empresa — la propuesta mostrará su nombre personal.",
    noClient: "Este proyecto no tiene datos del cliente, así que Preparado para quedará vacío.",
    fixInAccount: "Agrégalo en Cuenta →",
    fixInProject: "Agrégalos en el proyecto →",
  },

  account: {
    eyebrow: "Configuración",
    title: "Cuenta",
    profileSection: "Perfil",
    displayName: "Nombre de usuario",
    saveNameBtn: "Guardar nombre",
    saving: "Guardando…",
    nameUpdated: "Nombre actualizado.",
    passwordSection: "Cambiar contraseña",
    currentPassword: "Contraseña actual",
    newPassword: "Nueva contraseña",
    confirmNewPassword: "Confirmar nueva contraseña",
    changePasswordBtn: "Cambiar contraseña",
    changing: "Cambiando…",
    passwordChanged: "Contraseña cambiada con éxito.",
    passwordsNoMatch: "Las contraseñas nuevas no coinciden.",
    passwordTooShort: "La nueva contraseña debe tener al menos 8 caracteres.",
    sessionSection: "Sesión",
    signedInAs: "Sesión iniciada como",
    signOut: "Cerrar sesión",
    updateFailed: "Error al actualizar",
    changeFailed: "Error al cambiar la contraseña",
    logoSection: "Logotipo de la empresa",
    logoHint: "PNG o JPEG, máx. 2 MB. Su logotipo aparece en el encabezado de cada estimación en PDF que envíe.",
    noLogo: "Sin logotipo",
    uploadLogo: "Subir logotipo",
    replaceLogo: "Reemplazar logotipo",
    removeLogo: "Eliminar",
    logoUploading: "Subiendo…",
    logoUpdated: "Logotipo actualizado. Aparecerá en sus estimaciones en PDF.",
    logoRemoved: "Logotipo eliminado.",
    logoTooLarge: "El logotipo debe pesar menos de 2 MB.",
    logoWrongType: "El logotipo debe ser una imagen PNG o JPEG.",
    logoUploadFailed: "Error al subir el logotipo",
    namePh: "Su nombre",
  },

  aiAssistant: {
    eyebrow: "Asistente IA",
    poweredBy: "Impulsado por Claude — analiza, valida y genera texto de propuesta.",
    recommend: "Recomendar categorías",
    validate: "Validar estimación",
    generateProposal: "Generar propuesta",
    analyzeProfit: "Analizar ganancias",
    loading: "Cargando…",
    proposalLabel: "Texto de la propuesta",
    proposalPlaceholder: "La propuesta generada por IA aparecerá aquí…",
    profit_title: "Análisis de ganancias",
    no_analysis: "Sin análisis aún.",
    error: "Error de la IA.",
    suggestionsTitle: "Conjuntos sugeridos",
    ruleOfThumb: "Regla práctica: {{value}}",
    issuesTitle: "Problemas detectados",
    noIssues: "✓ Sin problemas.",
    suggestion: "Sugerencia: {{value}}",
    proposalHint: "Revísela antes de copiarla a su propuesta final.",
    contract: "Contrato",
    risks: "Riesgos",
    severityHigh: "Alta",
    severityMedium: "Media",
    severityLow: "Baja",
  },

  receiptUpload: {
    eyebrow: "Subir recibo",
    selectFile: "Seleccionar imagen o PDF",
    upload: "Subir recibo",
    uploading: "Subiendo…",
    success: "Recibo subido con éxito.",
    error: "Error al subir.",
  },

  locationAutocomplete: {
    placeholder: "Calle, ciudad, código postal",
  },

  downloadPdf: {
    button: "Descargar PDF",
    downloading: "Descargando…",
    title: "Descargar la propuesta en PDF",
    failed: "No se pudo descargar el PDF.",
  },

  home: {
    // Nav
    previewMenu: "Vista previa",
    previewSamplePages: "Páginas de muestra",
    previewProjects: "Proyectos",
    previewEstimates: "Estimaciones",
    previewExpenses: "Gastos",
    navLogIn: "Iniciar sesión",
    navGetStarted: "Comenzar",
    navGetStartedArrow: "Comenzar →",

    // Hero
    heroBadgeTop: "Cree su",
    heroBadgeScript: "estimación perfecta",
    heroTagline: "Estimaciones y propuestas para jardineros",
    ctaDemo: "Ver la demostración",
    ctaDemoBusy: "Abriendo la demostración…",
    ctaDemoFailed: "No se pudo abrir la demostración. Inténtalo de nuevo.",
    ctaGetStarted: "Comenzar",
    ctaSeeHow: "Ver cómo funciona",

    // Features section
    featuresEyebrow: "Todo lo que necesita",
    featuresHeading: "Diseñado para el campo",
    feature1Title: "Estimaciones al instante",
    feature1Desc: "Seleccione una categoría, ingrese los metros cuadrados y obtenga un desglose completo de costos en segundos.",
    feature2Title: "Precios actualizados",
    feature2Desc: "Tarifas laborales regionales y costos de materiales aplicados automáticamente según su código postal.",
    feature3Title: "Propuestas en PDF",
    feature3Desc: "Genera documentos de propuesta profesionales con un clic, directamente desde cualquier estimación.",
    feature4Title: "Control de presupuesto",
    feature4Desc: "Registre gastos por proyecto y observe su ganancia bruta actualizada en tiempo real.",

    // Sample sections
    sampleHeadingProjects: "Organice cada trabajo",
    sampleBodyProjects: "Mantenga todos sus trabajos de paisajismo en un solo lugar. Cada proyecto tiene sus propias estimaciones, gastos y PDFs — sin más búsquedas en carpetas.",
    sampleCtaProjects: "Ver proyectos de muestra",
    sampleHeadingEstimates: "Desglose de costos al instante",
    sampleBodyEstimates: "Elija una categoría, ingrese los metros cuadrados y su código postal — las tarifas y costos se aplican automáticamente. Descargue un PDF listo para el cliente con un clic.",
    sampleCtaEstimates: "Ver estimaciones de muestra",
    sampleHeadingExpenses: "Controle cada dólar",
    sampleBodyExpenses: "Registre recibos en cualquier proyecto y observe el uso del presupuesto en tiempo real. Detecte sobrecostos antes de que se conviertan en problemas.",
    sampleCtaExpenses: "Ver gastos de muestra",

    // Final CTA
    ctaBottomEyebrow: "¿Listo para comenzar?",
    ctaBottomTitle: "Su primera estimación es gratis",
    ctaBottomSub: "Cree una cuenta en segundos y empiece a armar estimaciones profesionales hoy. Sin tarjeta de crédito.",
    ctaCreateAccount: "Crear cuenta gratis",
    ctaSignIn: "Iniciar sesión",
    authNavAria: "Acceso a la cuenta",
    scrollDownAria: "Bajar",
    previewProjectsCount: "3 proyectos activos",
    previewProject1: "Renovación de patio en Riverside",
    previewProject2: "Jardín delantero en Oak Street",
    previewProject3: "Áreas comunes HOA en Sunnyvale",
    previewStatusActive: "Activo",
    previewStatusCompleted: "Terminado",
    previewStatusEstimating: "En cotización",
    previewEstimateTitle: "Instalación de césped",
    previewEstimateMeta: "1,200 pies² · San Jose, CA 95110",
    previewLineSod: "Césped (1,200 pies²)",
    previewLineSoil: "Preparación de suelo y nivelación",
    previewLineEdging: "Bordes y bordillos",
    previewLineDelivery: "Entrega",
    previewRecentExpenses: "Gastos recientes",
    previewExpenseDate1: "18 mar",
    previewExpenseDate2: "20 mar",
    previewExpenseDate3: "21 mar",
    ctaDemoWaking: "Encendiendo el servidor…",
    ctaDemoWakingHint: "El servidor de la demostración se apaga cuando nadie lo usa. La primera visita tarda unos 30 segundos.",
  },
  pricing: {
    eyebrow: "Hoja de precios",
    title: "Mis tarifas",
    intro: "Cada estimación se calcula con estos precios. Materiales: lo que paga, con impuesto incluido; su margen se agrega en la cotización. Mano de obra: lo que cobra.",
    restoreDefaults: "Restablecer",
    restoring: "Restableciendo…",
    allSaved: "Todo guardado",
    saveOne: "Guardar 1 cambio",
    saveMany: "Guardar {{count}} cambios",
    savedOne: "1 precio guardado.",
    savedMany: "{{count}} precios guardados.",
    nothingChanged: "No hay cambios que guardar.",
    priceInvalid: "\"{{item}}\" necesita un precio de 0 o más.",
    unitRequired: "\"{{item}}\" necesita una unidad.",
    loadFailed: "No se pudo cargar la hoja de precios.",
    saveFailed: "No se pudieron guardar los precios.",
    addRequired: "Nombre, unidad y precio son obligatorios.",
    duplicateItem: "Ya hay un artículo con ese nombre en esta categoría.",
    itemAdded: "\"{{item}}\" agregado.",
    addFailed: "No se pudo agregar el artículo.",
    confirmDelete: "¿Eliminar \"{{item}}\"? Las estimaciones ya hechas lo conservan.",
    itemDeleted: "\"{{item}}\" eliminado.",
    deleteFailed: "No se pudo eliminar el artículo.",
    confirmReset: "¿Restablecer los precios predeterminados? Los artículos propios se conservan.",
    resetDone: "Precios predeterminados restablecidos.",
    resetFailed: "No se pudieron restablecer los precios.",
    markupRange: "El margen debe ser un porcentaje entre 0 y 500.",
    taxRange: "El impuesto debe ser un porcentaje entre 0 y 20.",
    settingsSaved: "Configuración guardada.",
    settingsSaveFailed: "No se pudo guardar la configuración.",
    howYouQuote: "Cómo cotiza",
    materialsMarkup: "Margen en materiales",
    markupHint: "Se suma a materiales y renta de equipo. Nunca a la mano de obra.",
    salesTax: "Impuesto local (T&M)",
    salesTaxPh: "ej. 9.375",
    salesTaxHint: "Solo en tiempo y materiales, y solo sobre materiales. Obligatorio para cotizar T&M.",
    defaultContract: "Tipo de contrato predeterminado",
    lumpSum: "Precio global",
    timeAndMaterials: "Tiempo y materiales",
    contractHint: "Se puede cambiar en cada estimación.",
    saveSettings: "Guardar configuración",
    addItem: "Agregar artículo",
    item: "Artículo",
    price: "Precio",
    unit: "Unidad",
    yours: "Propio",
    edited: "Editado",
    unsaved: "Sin guardar",
    customerPrice: "· cliente ${{amount}}",
    unitAria: "{{item}} unidad",
    notesAria: "{{item}} notas",
    notesPh: "Notas opcionales…",
    newItem: "Nuevo artículo",
    newItemPh: "ej. Arce japonés – caja 24\"",
    unitPh: "unidad",
  },
  categories: {
    eyebrow: "Biblioteca",
    intro: "Todas las categorías de trabajo disponibles para sus estimaciones. Ajuste los precios unitarios en la Hoja de precios.",
    allCategories: "Todas las categorías",
    emptyState: "Aún no hay categorías.",
    emptyStateHint: "Las categorías aparecerán aquí cuando se agreguen al sistema.",
    loadError: "No se pudieron cargar las categorías.",
    countAssemblies: "{{count}} conjuntos",
    countItems: "{{count}} elementos",
    countTemplates: "{{count}} plantillas",
    countLines: "{{count}} líneas",
    unitLabel: "Unidad",
    wastePct: "Desperdicio: {{pct}}%",
    templates: "Plantillas",
    tradeDemo: "Demolición / Prep. del sitio",
    tradeSoilPrep: "Preparación del suelo",
    tradeIrrigation: "Riego",
    tradeHardscape: "Paisaje duro",
    tradeConcrete: "Concreto",
    tradePlanting: "Plantas / Césped",
    tradeMulchRock: "Mantillo / Roca",
    tradeLighting: "Iluminación de paisaje (bajo voltaje)",
    tradeCleanup: "Limpieza final",
    tradeLabor: "Mano de obra general",
    tradeOther: "Otros",
  },
  assemblies: {
    title: "Conjuntos",
    loading: "Cargando conjuntos…",
    loadError: "No se pudieron cargar los conjuntos ni las plantillas. Intente de nuevo.",
    emptyState: "No hay conjuntos.",
    unitFallback: "unidad",
    itemsWaste: "{{count}} elementos • {{pct}}% desperdicio",
    templates: "Plantillas",
    emptyTemplates: "No hay plantillas.",
    countLines: "{{count}} líneas",
  },
  estimateEditor: {
    eyebrow: "Editar estimación",
    untitled: "Estimación #{{num}}",
    notFound: "No se encontró la estimación",
    loadFailed: "No se pudo cargar la estimación",
    saveFailed: "No se pudo guardar",
    repriceFailed: "No se pudieron actualizar los precios",
    checkPricesFailed: "No se pudieron consultar los precios",
    legacyNote: "Esta estimación se hizo antes de que existiera la edición. Cree una nueva desde su hoja de precios para hacer cambios.",
    approvedLocked: "Aprobada y bloqueada. Los cambios al trabajo aprobado se hacen con una orden de cambio, así el presupuesto aprobado no se mueve.",
    reopenToEdit: "Reábrala como borrador para editarla.",
    changeOrders: "Órdenes de cambio",
    newEstimate: "Nueva estimación",
    allEstimates: "Todas las estimaciones",
    repriceFromSheet: "Actualizar precios",
    saveChanges: "Guardar cambios",
    savedState: "Guardado",
    savedOk: "Estimación guardada.",
    savedBackToDraft: "Guardado. Volvió a Borrador: envíe la versión nueva al cliente.",
    alreadySentNote: "Esta estimación ya se envió. Al guardar vuelve a Borrador, para recordarle enviar la versión nueva al cliente.",
    repriceHeading: "Precios de su hoja actual",
    repriceNoChanges: "No hay nada que cambiar: la estimación ya tiene sus precios actuales.",
    materialsMarkup: "Margen en materiales",
    noLongerOnSheet: "Ya no están en su hoja (se conserva el precio): {{items}}",
    adjustedPricesKept: "Los precios ajustados para este trabajo y las partidas únicas no cambian.",
    apply: "Aplicar",
    repricedOk: "Precios actualizados con su hoja de precios actual.",
    unsavedWarning: "Tiene cambios sin guardar: al aplicar se descartan y queda la versión guardada con los precios nuevos.",
    contractLumpSum: "Precio global",
    contractTimeMaterials: "Tiempo y materiales",
    taxSetupPre: "Configure su impuesto local en ",
    taxSetupLink: "la hoja de precios",
    taxSetupPost: " primero.",
    catDemo: "Demolición / Preparación",
    catSoilPrep: "Preparación del suelo",
    catIrrigation: "Riego",
    catHardscape: "Paisaje duro",
    catConcrete: "Concreto",
    catPlanting: "Plantas / Césped",
    catMulchRock: "Mantillo / Roca",
    catLighting: "Iluminación",
    catCleanup: "Limpieza",
    catLabor: "Mano de obra adicional",
    kindMaterial: "Material",
    kindEquipment: "Equipo",
    kindLabor: "Mano de obra",
    priceMaterial: "Usted paga",
    priceEquipment: "Costo de renta",
    priceLabor: "Usted cobra",
    oneOffChip: "Única",
    adjustedChip: "Ajustado (antes {{price}})",
    quantity: "Cantidad",
    quantityAria: "Cantidad de {{item}}",
    priceAria: "Precio de {{item}}",
    customerPrice: "cliente",
    reset: "Restablecer",
    remove: "Quitar",
    removeAria: "Quitar {{item}}",
    addToEstimate: "Agregar a la estimación",
    itemLabel: "Artículo",
    itemFromSheetPh: "Artículo de su hoja…",
    itemAlreadyAdded: "Esa partida ya está en la estimación.",
    oneOffLine: "Partida única",
    oneOffNamePh: "ej. Colocación de rocas",
    oneOffNameAria: "Nombre de la partida única",
    kindLabel: "Tipo de partida",
    unitPh: "unidad",
    unitLabel: "Unidad",
    oneOffRequired: "Una partida única necesita nombre, unidad y precio.",
    oneOffNote: "Una partida única es solo para esta estimación; no se agrega a su hoja de precios.",
    checkQtyPrice: "Revise la cantidad y el precio de \"{{item}}\".",
    needsOneItem: "La estimación necesita al menos una partida con cantidad.",
    salesTaxOnMaterials: "Impuesto sobre materiales",
    markupNote: "Margen en materiales de esta estimación: {{pct}}%.",
    previewNote: "Vista previa: guarde para aplicar.",
    reviewApprove: "Revisar y aprobar",
    pdfLastSaved: "El PDF muestra la última versión guardada.",
  },
  sample: {
    ariaDemoTabs: "Pestañas de la demostración",
    ariaAuth: "Acceso",
    backHome: "← Inicio",
    bannerPreview: "Vista de muestra — Datos de ejemplo.",
    bannerSignUpLink: "Regístrese para usarlo de verdad →",
    projectsEyebrow: "Su trabajo",
    newProject: "+ Nuevo proyecto",
    alertCreateProject: "Regístrese para crear proyectos reales.",
    alertViewProject: "Regístrese para ver los detalles del proyecto.",
    alertViewEstimates: "Regístrese para ver las estimaciones.",
    totalProjects: "Total de proyectos",
    combinedBudget: "Presupuesto total",
    statusActive: "Activo",
    statusCompleted: "Terminado",
    statusEstimating: "En estimación",
    createdOn: "Creado el {{date}}",
    estimateOne: "{{count}} estimación",
    estimateMany: "{{count}} estimaciones",
    spentAmount: "{{amount}} gastado",
    budgetAmount: "{{amount}} presupuesto",
    budgetUsed: "Presupuesto usado",
    ctaProjectsEyebrow: "¿Listo para controlar sus propios proyectos?",
    projectRiverside: "Renovación de patio en Riverside",
    projectOakStreet: "Jardín frontal en Oak Street",
    projectSunnyvaleHoa: "Áreas comunes HOA Sunnyvale",
    projectPaloAlto: "Rediseño resistente a la sequía en Palo Alto",
    projectCampbell: "Mejora de riego en Campbell",
    projectRiversideShort: "Patio Riverside",
    projectPaloAltoShort: "Rediseño Palo Alto",
    projectSunnyvaleShort: "HOA Sunnyvale",
    filterAll: "Todos",
    clientTorres: "Michael y Sandra Torres",
    clientCitySunnyvale: "Ciudad de Sunnyvale",
    clientRidgecrestHoa: "HOA Ridgecrest",
    clientChiu: "Dra. Helen Chiu",
    clientEvergreen: "Evergreen Estates LLC",
    locSanJose: "San Jose, CA",
    locSunnyvale: "Sunnyvale, CA",
    locPaloAlto: "Palo Alto, CA",
    locCampbell: "Campbell, CA",
    dateMar012026: "1 mar 2026",
    dateMar022026: "2 mar 2026",
    dateMar052026: "5 mar 2026",
    dateMar062026: "6 mar 2026",
    dateMar182026: "18 mar 2026",
    dateMar192026: "19 mar 2026",
    dateMar202026: "20 mar 2026",
    dateMar212026: "21 mar 2026",
    dateMar222026: "22 mar 2026",
    dateJan142026: "14 ene 2026",
    dateFeb282026: "28 feb 2026",
    dateDec032025: "3 dic 2025",
    estimatesEyebrow: "Desglose de costos",
    newEstimate: "+ Nueva estimación",
    alertBuildEstimates: "Regístrese para armar estimaciones reales.",
    alertDownloadPdf: "Regístrese para descargar PDF reales.",
    alertEditEstimates: "Regístrese para editar estimaciones.",
    estimateMeta: "{{sqft}} pies² · ZIP {{zip}} · Creado el {{date}}",
    total: "Total",
    downloadPdf: "Descargar PDF",
    allEstimates: "Todas las estimaciones",
    combined: "Combinado",
    supportedAssemblies: "Conjuntos disponibles",
    ctaEstimatesBody: "Regístrese para armar estimaciones con sus propios proyectos, conjuntos y códigos postales.",
    asmSod: "Instalación de césped",
    asmDripSystem: "Sistema de riego por goteo",
    asmDgPathway: "Sendero de granito descompuesto",
    asmDripIrrigation: "Riego por goteo",
    asmHardscape: "Obra dura / granito",
    asmMulch: "Mantillo y cubresuelos",
    asmTreeShrub: "Árboles y arbustos",
    asmTurfRemoval: "Retiro de césped",
    liSodMaterial: "Césped en rollo (mezcla Bermuda)",
    liSoilPrep: "Preparación de suelo y nivelación final",
    liConcreteEdging: "Bordillo y remates de concreto",
    liDeliveryAllocated: "Entrega (prorrateada)",
    liDripEmitters: "Goteros y manguera (1,200 pies)",
    liBackflow: "Válvula antirretorno y filtro",
    liTimer: "Temporizador / controlador",
    liInstallLabor: "Mano de obra de instalación",
    liDgMaterial: "Granito descompuesto (3\" de espesor)",
    liWeedBarrier: "Tela antimaleza",
    liSteelEdging: "Bordillo de acero (140 pies)",
    liLaborCompact: "Mano de obra — instalar y compactar",
    expensesEyebrow: "Control de gastos",
    logExpense: "+ Registrar gasto",
    alertLogExpenses: "Regístrese para registrar gastos reales.",
    expenseOne: "{{count}} gasto",
    expenseMany: "{{count}} gastos",
    receipt: "Recibo",
    totalLogged: "Total registrado",
    transactionsCount: "{{count}} transacciones",
    budgetVsActual: "Presupuesto vs. real",
    byCategory: "Por categoría",
    ctaExpensesBody: "Registre gastos con fotos de recibos, filtre por proyecto y exporte reportes.",
    ctaStartTracking: "Empezar a registrar →",
    catMaterials: "Materiales",
    catSubcontractor: "Subcontratista",
    catEquipment: "Equipo",
    catDelivery: "Entrega",
    vendorSodSource: "SodSource Inc.",
    vendorManuelGrading: "Manuel's Grading Co.",
    vendorLowes: "Lowe's – Milpitas",
    vendorHomeDepot: "Home Depot",
    vendorPeninsula: "Peninsula Landscape Supply",
    vendorBayAreaSteel: "Bay Area Steel Edging",
    vendorFastFlatbed: "Fast Flatbed Delivery",
    vendorPacificCoast: "Pacific Coast Irrigation",
  },
  proposalViewer: {
    title: "Propuesta",
    noEstimateId: "No se indicó ninguna estimación.",
    approvedLocked: "Aprobada y bloqueada. Los cambios al trabajo aprobado se hacen con una orden de cambio.",
    rejected: "Rechazada. Reábrala como borrador para aprobarla.",
    approveEstimate: "Aprobar estimación (bloquear y crear presupuesto)",
    approving: "Aprobando…",
    editFirst: "Editar primero",
    finalized: "Estimación aprobada y presupuesto creado. Ya aparece en la página de Gastos.",
    approveFailed: "No se pudo aprobar la estimación.",
    loadFailed: "No se pudo cargar esta propuesta.",
    loading: "Cargando la propuesta…",
    openNewTab: "Abrir en otra pestaña",
    cantSee: "¿No se ve?",
  },
  openPdf: {
    opening: "Abriendo…",
    failed: "No se pudo abrir el PDF.",
    title: "Abrir la propuesta en PDF en otra pestaña",
  },
  catalog: {
    item: {
      demoLabor: "Mano de obra de demolición",
      haulAway: "Acarreo de escombro",
      grading: "Nivelación",
      topsoil: "Tierra vegetal",
      soilAmendment: "Mejorador de suelo",
      soilPrepLabor: "Mano de obra de preparación",
      dripLine: "Manguera de goteo",
      sprinklerHead: "Cabezal de aspersor",
      irrigationLabor: "Mano de obra de riego",
      pavers: "Adoquines",
      baseRock: "Base de grava (Clase II)",
      sandBase: "Base de arena",
      geotextile: "Tela geotextil",
      edgeRestraint: "Borde de contención",
      polymericSand: "Arena polimérica",
      plateCompactor: "Renta de compactadora",
      hardscapeLabor: "Mano de obra de obra dura",
      concrete: "Concreto",
      formLabor: "Mano de obra de cimbra",
      concreteLabor: "Mano de obra de concreto",
      sod: "Césped en rollo",
      groundcoverFlat: "Cubresuelo – charola",
      plant1Gal: "Planta – 1 gal",
      plant5Gal: "Planta – 5 gal",
      plant15Gal: "Planta – 15 gal",
      tree24Box: "Árbol – caja 24\"",
      tree36Box: "Árbol – caja 36\"",
      plantingLabor: "Mano de obra de siembra",
      woodMulch: "Mantillo de madera",
      crushedRock: "Grava triturada",
      decorativeRock: "Piedra decorativa",
      mulchInstallLabor: "Mano de obra de mantillo",
      lightFixture: "Luminaria",
      lowVoltWire: "Cable de bajo voltaje",
      transformer: "Transformador",
      lightingLabor: "Mano de obra de iluminación",
      finalCleanupLabor: "Mano de obra de limpieza final",
      debrisRemoval: "Retiro de escombro",
      generalLabor: "Mano de obra general",
      foreman: "Capataz",
      equipmentOperator: "Operador de equipo",
    },
  },
  category: {
    demo: "Demolición / Preparación",
    soilPrep: "Preparación del suelo",
    irrigation: "Riego",
    hardscape: "Paisaje duro",
    concrete: "Concreto",
    planting: "Plantas / Césped",
    mulchRock: "Mantillo / Roca",
    lighting: "Iluminación",
    cleanup: "Limpieza",
    labor: "Mano de obra adicional",
    other: "Otro",
  },
  categoryHint: {
    demo: "Demolición, retiro de escombros, nivelación",
    soilPrep: "Tierra, enmiendas, labranza",
    irrigation: "Línea de goteo, aspersores",
    hardscape: "Adoquines, base, bordes",
    concrete: "Losas, cimbras",
    planting: "Plantas por tamaño de maceta, árboles, césped",
    mulchRock: "Corteza, roca triturada y decorativa",
    lighting: "Lámparas, cable, transformador",
    cleanup: "Limpieza final, retiro de escombros",
    labor: "Horas de cuadrilla no incluidas arriba",
    other: "Cualquier trabajo no incluido arriba",
  },
};
